import { useEffect } from 'react';
import './ifs.css'
import Navbar from '../Components/navbar'
import Footer from '../Components/Footer';







import PR1 from '../images/PR1.webp'
import PR2 from '../images/PR2.webp'
import PR3 from '../images/PR3.webp'
import PR4 from '../images/PR4.png'
import PR6 from '../images/PR6.jpg'


import PR5 from '../images/PR5.jpg'

 



export default function IFA() {

useEffect(() => {
       window.scrollTo(0, 0); // Scroll to the top of the page
     }, []);



  return (
    <>
       
       <Navbar/>
       
     
       
   
   
       
       <section id="product" style={{ padding: '20px' }}>
         <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Inserts For Aluminium</h2>
         <div className="product-grid">
           
           <div className="product-card">
             <img src={PR1} alt="Graphics Card" />
             <h3>Insets</h3>
            
           </div>
           <div className="product-card">
             <img src={PR2} alt="Processor" />
             <h3>Insets</h3>
             
           </div>
           <div className="product-card">
             <img src={PR3} alt="Motherboard" />
             <h3>Insets</h3>
            
           </div>
           <div className="product-card">
             <img src={PR4} alt="RAM 16GB" />
             <h3>Insets</h3>
             
           </div>
           <div className="product-card">
             <img src={PR5} alt="SSD 1TB" />
             <h3>Insets</h3>
             
           </div>
       
           <div className="product-card">
             <img src={PR6} alt="Power Supply" />
             <h3>Insets</h3>
             
           </div>
         
          
          
          
           
         </div>
       </section>
       <Footer/>
       
       </>
  )
}
